enum WarningStatus {
  UNEXPECTED_PARAMETER = 'UnexpectedParameter',
}

export default WarningStatus;
